require('./bootstrap');
require('./external/jquery.cookie');
require('./external/select2/select2.min');
require('./external/datepicker/bootstrap-datetimepicker.min');
require('./external/jquery.alphanumeric');
require('./external/summernote/summernote-bs5.min.js');
require('./external/passrequirements/PassRequirements.js');
require('./external/bootstrap-maxlength.min.js');
window.bootbox = require('bootbox');
require('./master');



